// Deployment configuration for different platforms
export const getBasePath = () => {
  // For GitHub Pages
  if (process.env.REACT_APP_DEPLOY_TARGET === 'github') {
    return process.env.PUBLIC_URL || '/Lakhdeep-Master-Portfolio';
    // lakhdeepjawandha.github.io
  }
  
  // For Netlify, Vercel, or custom servers
  if (process.env.REACT_APP_DEPLOY_TARGET === 'netlify' || 
      process.env.REACT_APP_DEPLOY_TARGET === 'vercel' ||
      process.env.REACT_APP_DEPLOY_TARGET === 'custom') {
    return '/';
  }
  
  // Default fallback
  return process.env.PUBLIC_URL || '/';
};

export const getPublicUrl = () => {
  return process.env.PUBLIC_URL || '';
};